export const adjustmentLevelColor = (level?: string | null): string => {
  switch (level?.trim().toLowerCase()) {
    case 'bajo':
      return '#B42318'
    case 'medio':
      return '#946200'
    case 'alto':
      return '#187347'
    default:
      return '#6B8294'
  }
}
